module.exports = __webpack_public_path__ + "static/media/india_.cc85e1e3.png";